module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Battery-half-0700ca18928d4f91234763d3b855e95d.svg";